// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='HomeTabUpload'] .pseudo-button {\n    color: var(--primary-style-color);\n    border: 1px dashed var(--primary-style-color);\n    padding: 33px 20px 33px 40px;\n    text-align: center;\n    position: relative;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    line-height: 15px;\n    background-image: var(--upload-asset-image);\n    background-repeat: no-repeat;\n    background-position: calc(50% - 55px) 50%;\n  }\n", ""]);
// Exports
module.exports = exports;
